var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurgerButtonWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 69 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.75 6.98H4.19002C2.65002 6.98 1.40002 5.73 1.40002 4.19C1.40002 2.65 2.65002 1.4 4.19002 1.4H64.74C66.28 1.4 67.53 2.65 67.53 4.19C67.53 5.73 66.28 6.98 64.74 6.98H64.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19 8.38C6.50407 8.38 8.38 6.50407 8.38 4.19C8.38 1.87593 6.50407 0 4.19 0C1.87593 0 0 1.87593 0 4.19C0 6.50407 1.87593 8.38 4.19 8.38Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.75 27.6H4.19002C2.65002 27.6 1.40002 26.35 1.40002 24.81C1.40002 23.27 2.65002 22.02 4.19002 22.02H64.74C66.28 22.02 67.53 23.27 67.53 24.81C67.53 26.35 66.28 27.6 64.74 27.6H64.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.42 21.13H61.06V28.49H68.42V21.13Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.75 48.21H4.19002C2.65002 48.21 1.40002 46.96 1.40002 45.42C1.40002 43.88 2.65002 42.63 4.19002 42.63H64.74C66.28 42.63 67.53 43.88 67.53 45.42C67.53 46.96 66.28 48.21 64.74 48.21H64.75Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19 49.61C6.50407 49.61 8.38 47.7341 8.38 45.42C8.38 43.1059 6.50407 41.23 4.19 41.23C1.87593 41.23 0 43.1059 0 45.42C0 47.7341 1.87593 49.61 4.19 49.61Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerButtonWhite);
export default __webpack_public_path__ + "static/media/burgerButton-white.6eb7aebb6e4c5b3cf99afe585586ae7d.svg";
export { ForwardRef as ReactComponent };